import { usePrerollDurationWatcher } from '../../feature-player/hooks/skin/use-preroll-duration';

import { useEpisodeCurrentStream } from './use-episode-current-stream';

export const useEpisodePrerollDurationWatcher = (contentId: string) =>
    usePrerollDurationWatcher(useEpisodeCurrentStream(contentId));
